import { render, staticRenderFns } from "./MobileIdentityHeader.vue?vue&type=template&id=320f8c26&lang=html&"
import script from "./MobileIdentityHeader.vue?vue&type=script&lang=js&"
export * from "./MobileIdentityHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports